var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success-icon",
    transform: "translate(-551 -240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 16,
    height: 16,
    transform: "translate(551 240)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M1.667,6.387h2v8h-2A.667.667,0,0,1,1,13.72V7.053A.667.667,0,0,1,1.667,6.387ZM5.2,5.525,9.462,1.258A.333.333,0,0,1,9.9,1.227l.568.426A1,1,0,0,1,10.835,2.7l-.769,3.02h4.267a1.333,1.333,0,0,1,1.333,1.333v1.4a1.334,1.334,0,0,1-.1.508L13.5,13.974a.667.667,0,0,1-.616.413H5.667A.667.667,0,0,1,5,13.72V6A.667.667,0,0,1,5.2,5.525Z",
    transform: "translate(550.667 240.173)",
    fill: "#7aba56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.8c7fed88400683418046eb4ed8e040a7.svg";
export { ForwardRef as ReactComponent };